module.exports = __webpack_public_path__ + "static/media/battery_inactive.1182c6ec.svg";